export default class Justificativa {
    constructor() {
        this.id = null;
        this.descricao = '';
        this.inibirAcesso = false;
        this.tipo = 1;
        this.descricaoTipo = '';
    }    
}